// @ts-check

class LoadMore extends HTMLElement {
  static #loadingClass = 'is-loading'
  static tagName = 'load-more'

  connectedCallback() {
    this.abortController = new AbortController()

    /**
     * @param {Event} event
     */
    this.addEventListener(
      'loadMore',
      async (event) => {
        if (!(event.target instanceof HTMLElement)) return
        event.preventDefault()
        if (
          !event.target.dataset.href ||
          !event.target.dataset.sectionId ||
          !event.target.dataset.target
        )
          return
        this.classList.add(LoadMore.#loadingClass)
        try {
          let contents = await this.fetchContents(
            event.target.dataset.href,
            event.target.dataset.sectionId,
            event.target.dataset.target
          )
          document
            .querySelector(event.target.dataset.target)
            ?.insertAdjacentHTML('beforeend', contents.target)
          window.history.pushState({}, '', event.target.dataset.href)
          this.classList.remove(LoadMore.#loadingClass)
          this.outerHTML = contents.loadMore
        } catch (error) {
          console.error(error)
          this.classList.remove(LoadMore.#loadingClass)
        }
      },
      { signal: this.abortController.signal }
    )

    window.addEventListener('popstate', () => window.location.reload(), {
      signal: this.abortController.signal,
    })
  }

  disconnectedCallback() {
    this.abortController?.abort()
  }

  /**
   * @param {string} path
   * @param {string} sectionId
   * @param {string} target
   */
  async fetchContents(path, sectionId, target) {
    let url = new URL(path, window.location.origin)
    url.searchParams.set('section_id', sectionId)
    let response = await fetch(url)
    if (!response.ok) throw new Error(String(response.status))
    let responseText = await response.text()
    let html = new DOMParser().parseFromString(responseText, 'text/html')
    return {
      target: html.querySelector(target)?.innerHTML ?? '',
      loadMore: html.querySelector(LoadMore.tagName)?.outerHTML ?? '',
    }
  }
}

customElements.define(LoadMore.tagName, LoadMore)
